module.exports = __webpack_public_path__ + "img/icb-co-novice-m@3x.cc2cfbdc.png";